import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      lastErrorTime: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      error,
    };
  }

  componentDidMount() {
    if (window.localStorage) {
      this.setState({
        lastErrorTime: window.localStorage.getItem('lastChunkLoadErrorTime'),
      });
    }
  }

  componentDidCatch(error, errorInfo) { // eslint-disable-line no-unused-vars
    this.setState({
      error,
    });
  }

  render() {
    const { children } = this.props;
    const { error, lastErrorTime } = this.state;

    if (error) {
      if (error.name === 'ChunkLoadError') {
        if (window.localStorage) {
          window.localStorage.setItem('lastChunkLoadErrorTime', (new Date()).getTime().toString());
        }

        if (!lastErrorTime || ((new Date()).getTime() - Number(lastErrorTime) > 60000)) { // 1min
          window.location.reload();
        }
      }
    }

    return children;
  }
}

export default ErrorBoundary;
